<template>
  <a-card title="Profit Per-Month" :bordered="false">
    <a-skeleton :loading="loading" active>
      <chart-profit :chart-data="chartData" :options="options"></chart-profit>
    </a-skeleton>
  </a-card>
</template>

<script>
import ChartProfit from "./chart-profit";

export default {
  name: "chart-profit-container",
  components: {ChartProfit},
  props: {
    uri: {
      type: String,
      default: null
    }
  },
  mounted() {
    this.getItems()
  },
  data: () => ({
    loading: false,
    items: []
  }),
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.uri !== null ? this.uri : this.routeUri('hyperion.transaction.summary.profit'))
        .then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    }
  },
  computed: {
    chartData() {
      const labels = this.items.map(item => this.moment().month(item.month - 1).format("MMM")+' '+item.year)

      const data = {
        label: 'Profit',
        data: this.items.map(item => item.profit),
        fill: false
      }

      return {
        labels: labels,
        datasets: [data]
      }
    },
    options() {
      const currency = (value) => this.currency(value)
      return {
        plugins: {
          colorschemes: {
            scheme: "brewer.Accent6"
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              offsetGridLines: true
            },
            ticks: {
              stepSize: 10000000,
              callback: function(value, index, values) {
                return currency(value);
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              return label + currency(tooltipItem.yLabel)
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
